import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

/*
localStorage:
  searchEngine: 默认搜索引擎

*/

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
